var F = Object.defineProperty;
var B = (e, t, s) => t in e ? F(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s;
var c = (e, t, s) => B(e, typeof t != "symbol" ? t + "" : t, s);
class T {
  constructor(t, s, o, r) {
    c(this, "_side");
    // for better debugging (who handles message? iframe or website?)
    c(this, "_incomingMessageBus", null);
    c(this, "_outgoingMessageBus", null);
    c(this, "_execMessage", null);
    this._side = t, this._incomingMessageBus = s, this._outgoingMessageBus = o, this._execMessage = r, this._incomingMessageBus && this._incomingMessageBus.addEventListener(
      "message",
      this._handleMessage.bind(this)
    );
  }
  setOutgoingMessageBus(t) {
    this._outgoingMessageBus = t;
  }
  setMessageExecution(t) {
    this._execMessage = t;
  }
  sendMessage(t, s = []) {
    return new Promise((o, r) => {
      if (this._incomingMessageBus === this._outgoingMessageBus)
        return o(void 0);
      const n = new MessageChannel();
      n.port1.onmessage = (i) => {
        if (!i || !i.data)
          return n.port1.close(), n.port2.close(), r(
            new Error(
              this._side + " received message but response can not be interpreted"
            )
          );
        let l;
        try {
          l = JSON.parse(i.data);
        } catch (d) {
          return n.port1.close(), n.port2.close(), this._prepareError(d), r(d);
        }
        l.error ? r(l.error) : l.result !== void 0 ? o(l.result) : o(void 0), n.port1.close(), n.port2.close();
      };
      let a = "";
      try {
        a = JSON.stringify({ message: t, args: s });
      } catch {
        return r(
          new Error(
            this._side + ": can not create command because it is not JSON.stringify able"
          )
        );
      }
      if (!this._outgoingMessageBus)
        return r(new Error(this._side + ": outgoing bus not set yet"));
      this._outgoingMessageBus.postMessage(a, "*", [
        n.port2
      ]);
    });
  }
  _handleMessage(t) {
    const s = t.ports && Array.isArray(t.ports) && t.ports.length > 0 ? t.ports[0] : null;
    if (t.data && s)
      try {
        const o = JSON.parse(t.data);
        if (!this._execMessage)
          return s.postMessage(
            JSON.stringify({
              error: this._side + " is not ready to handle messages"
            })
          );
        Array.isArray(o.args) || (o.args = [o.args]);
        const r = this._execMessage(o, t);
        if (r === void 0)
          return;
        r.then(
          (n = {}) => {
            let a, i;
            typeof n == "object" && n !== null && (a = n.error, i = n.result), a ? s.postMessage(
              JSON.stringify({ error: a })
            ) : i !== void 0 ? s.postMessage(
              JSON.stringify({ result: i })
            ) : s.postMessage(
              JSON.stringify({ result: n })
            );
          },
          (n) => {
            s.postMessage(
              JSON.stringify({
                error: this._prepareError(n)
              })
            );
          }
        );
      } catch (o) {
        s.postMessage(
          JSON.stringify({
            error: this._prepareError(o)
          })
        );
      }
  }
  _prepareError(t) {
    if (typeof t == "string") {
      const s = this._side + ": " + t;
      return console.error(s), s;
    }
    return t.message = this._side + ": " + t.message, console.error(t), t.message;
  }
}
const p = ".", E = {
  REQUEST_BOOT: "requestBoot",
  SETUP: "setup",
  WEBSITE_READY: "websiteReady"
}, _ = {
  GET_METHODS: "getMethods",
  RETURN_METHODS: "returnMethods",
  REGISTER_CUSTOM_VIEW: "registerCustomView",
  REGISTER_CUSTOM_VIEW_DONE: "registerCustomViewDone"
}, U = async (e, t) => {
  if (typeof e != "string")
    throw new Error(
      'Configurator ID is not a string type: "' + typeof e + '"'
    );
  const s = t.customApiUrl ? t.customApiUrl : "https://api.roomle.com/v2", o = t.overrideTenant || 9, r = s + "/configurators/" + e, n = "roomle_portal_v2", a = "03-" + window.btoa((/* @__PURE__ */ new Date()).toISOString() + ";anonymous;" + n), i = () => {
    const h = {
      apiKey: n,
      currentTenant: o,
      locale: "en",
      language: "en",
      device: 1,
      token: a,
      platform: "web"
    };
    return new Headers(h);
  }, l = new Request(r, {
    method: "GET",
    headers: i(),
    mode: "cors",
    cache: "default"
  }), d = await fetch(l), { configurator: g } = await d.json();
  return g;
}, W = () => {
  try {
    return window.self !== window.top;
  } catch {
    return !0;
  }
}, x = ["127.0.0.1", "localhost", "0.0.0.0"], k = () => {
  const e = W();
  let t = window.location.href;
  if (e) {
    if (!document.referrer)
      return null;
    t = document.referrer;
  }
  const { hostname: s } = new URL(t);
  return s;
}, G = (e) => !!(x.includes(e) || e.endsWith("roomle.com") || e.endsWith("gitlab.io") || e.endsWith("gitlab.com")), A = [
  "language",
  "browserLanguage",
  "userLanguage",
  "systemLanguage"
], V = (e = null) => {
  const t = window.navigator;
  if (e)
    return e.substr(0, 2);
  if (Array.isArray(t.languages) && t.languages.length > 0)
    return t.languages[0].substr(0, 2);
  for (let s = 0, o = A.length; s < o; s++) {
    const r = t[A[s]];
    if (r)
      return r.substr(0, 2);
  }
  return "en";
}, J = (e, t) => {
  const s = JSON.parse(JSON.stringify(e));
  return R(s, t);
}, R = (e, t) => {
  for (const s in t)
    try {
      t[s].constructor === Object ? e[s] = R(e[s], t[s]) : e[s] = t[s];
    } catch {
      e[s] = t[s];
    }
  return e;
};
var v = /* @__PURE__ */ ((e) => (e.BOTTOM_BAR = "bottom_bar", e.PARTLIST_BOUNDS = "partlist_bounds", e.INTERACTION_NOTES = "interaction_notes", e.PARAMETER_GROUPS = "parameter_groups", e))(v || {});
const $ = (e) => JSON.parse(JSON.stringify(e));
var z = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 };
const Y = {
  mobileLandscape: !0,
  floorMaterialRootTag: "materials_root",
  buttons: {
    renderimage: !0,
    requestproduct: !0,
    requestplan: !0,
    load_product: !0,
    partlist_print: !0
  },
  elements: {
    [v.INTERACTION_NOTES]: !0
  },
  helpcenter: {
    roomdesigner: !0,
    configurator: !1,
    disable: !1
  },
  firstPersonView: !0,
  saveToIdb: !0,
  featureFlags: {
    mocAr: !0,
    wallAutoHeight: !1,
    openCloseAnimation: !1
  },
  rotationSnapDegrees: 10,
  interactionsCollapsed: !1
}, q = "(idle)", K = (e) => (O(e), e != null && e.customApiUrl && (e.customApiUrl = decodeURIComponent(e.customApiUrl)), e.shareUrl && (e.deeplink = e.shareUrl.replace(
  Z,
  j
)), e), O = (e) => {
  if (!e)
    return;
  const t = Object.keys(e);
  for (const s of t) {
    const o = e[s];
    if (!Array.isArray(o) && typeof o == "object" && o !== null && O(o), Array.isArray(o))
      for (const r of o)
        O(r);
    (o === "true" || o === "false") && (e[s] = o === "true");
  }
}, Q = (e, t) => {
  t.configuratorId = e.id;
  const s = e.settings || {};
  return !t.overrideTenant && e.tenant && (t.overrideTenant = e.tenant), J(s, t);
}, X = () => {
  const e = $(Y);
  e.locale || (e.locale = V()), e.id === q && delete e.id;
  const t = k();
  return t && G(t) && (e.configuratorId = "demoConfigurator"), e.customApiUrl = z.VITE_RAPI_URL, e.emails = !1, e;
}, Z = "<CONF_ID>", j = "#CONFIGURATIONID#", ee = (e) => {
  e.featureFlags || (e.featureFlags = {}), typeof e.featureFlags.realPartList != "boolean" && (e.featureFlags.realPartList = !0), typeof e.featureFlags.globalCallbacks != "boolean" && (e.featureFlags.globalCallbacks = !0), typeof e.featureFlags.mocAr != "boolean" && (e.featureFlags.mocAr = !1);
}, y = () => /(android)/i.test(navigator.userAgent);
class M {
  constructor() {
    c(this, "_messageHandler", null);
    c(this, "isSetupDone", !1);
    c(this, "viewName", "main");
    c(this, "plugins", {});
    c(this, "pluginsLoaded", []);
    c(this, "ui", {
      callbacks: null
    });
    c(this, "extended", {
      callbacks: null
    });
    c(this, "configurator", {
      callbacks: null
    });
    c(this, "analytics", {
      callbacks: {}
    });
    c(this, "rapi", {
      callbacks: {}
    });
    c(this, "global", {
      callbacks: {}
    });
  }
  setMessageHandler(t) {
    this._messageHandler = t;
  }
  handleSetup(t) {
    const { methods: s, callbacks: o } = t;
    s.forEach((r) => {
      const n = r.split(p), a = n[0], i = n[1];
      this[a] || (this[a] = {}), this[a][i] = (function() {
        if (!this._messageHandler) {
          console.error("MessageHandler not set");
          return;
        }
        return this._messageHandler.sendMessage(r, [...arguments]);
      }).bind(this);
    }), o.forEach((r) => {
      const n = r.split(p), a = n[0], i = n[1], l = n[2];
      this[a] || (this[a] = {}), this[a][i] || (this[a][i] = {}), this[a][i][l] = () => {
      };
    }), this.isSetupDone = !0;
  }
  executeMessage({ message: t, args: s }) {
    const o = t.split(p), r = o[0], n = o[1], a = o.length === 3 ? o[2] : null;
    if (a && this[r][n][a]) {
      const i = this[r][n][a](
        ...s
      );
      return i instanceof Promise ? i.then((l) => ({ result: l })) : i !== void 0 ? Promise.resolve({ result: i }) : Promise.resolve({ result: null });
    }
    return Promise.reject('Message "' + t + '" is unkown');
  }
  setupPlugins(t, s, o = "website") {
    for (const r of t)
      typeof r == "string" && r === "dragIn" ? this.pluginsLoaded.push(
        new Promise((n, a) => {
          try {
            import("./drag-in-D5QSQ86J.mjs").then((i) => i.l).then(
              ({ DragIn: i }) => {
                const l = new i(
                  this.ui,
                  s,
                  o,
                  this.viewName
                );
                l.init().then(() => {
                  this.plugins.dragIn = l, n();
                }, a);
              }
            );
          } catch (i) {
            a(i);
          }
        })
      ) : r.name && r.loader && this.pluginsLoaded.push(
        new Promise((n, a) => {
          try {
            r.loader().then((i) => {
              const l = new i(
                this.ui,
                s,
                o,
                this.viewName
              );
              l.init().then(() => {
                this.plugins[r.name] = l, n();
              }, a);
            });
          } catch (i) {
            a(i);
          }
        })
      );
  }
}
const I = () => {
  let e, t;
  return { promise: new Promise((o, r) => {
    e = o, t = r;
  }), resolve: e, reject: t };
}, N = (e, t, s) => {
  let o = null;
  Object.defineProperty(e, t, {
    get() {
      return o || s;
    },
    set(r) {
      r != null && r.mute ? o = r.value : (console.warn(
        "You override Roomle defined behaviour. To disalbe this warning pass in an object with the following properties"
      ), console.warn("{ mute: true, value: () => void }"), o = r);
    }
  });
}, H = () => window.innerHeight * 0.01 + "px", L = (e) => {
  e && setTimeout(
    () => e.style.setProperty(S, H()),
    0
  );
}, b = "rml-styles", se = 450, S = "--rml-full-height", u = {
  CONTAINER: "rml-container",
  FILL: "rml-fill",
  POSITION: "rml-pos",
  TRANSITION: "rml-transition",
  ANDROID_HEIGHT: "rml-android-height",
  OVERFLOW_HIDDEN: "rml-overflow-hidden"
}, w = /* @__PURE__ */ new Map();
class re extends M {
  constructor(s, o, r, n, a) {
    super();
    c(this, "_waitForIframe");
    c(this, "_container");
    c(this, "_configuratorSettings");
    c(this, "_initData", {});
    c(this, "_iframe");
    if (!s || typeof s.id != "string")
      throw new Error(
        "Please provide a correct configuratorId, you get the correct ID from your Roomle Contact Person"
      );
    if (w.has(o))
      throw new Error("There is already an instance on this DOM element");
    if (!!!document.getElementById(b)) {
      const g = r.zIndex || 9999999, h = document.createElement("style");
      h.type = "text/css", h.id = b;
      const m = "transition:all ease-in-out " + se + "ms;", f = ["-webkit-", "-o-"].reduce(
        (C, D) => C += D + m,
        ""
      ) + m, P = H();
      h.innerHTML = `
        .${u.CONTAINER}{${S}:${P};}
        .${u.POSITION}{position:fixed;top:0;left:0;z-index:${g};opacity:0}
        .${u.TRANSITION}{${f}}
        .${u.FILL}{width:100%;height:100%;opacity:1}
        .${u.ANDROID_HEIGHT}{height:calc(var(${S},1vh)*100)}
        .${u.OVERFLOW_HIDDEN}{overflow:hidden}
      `, document.head.appendChild(h);
    }
    this._executeMessage = this._executeMessage.bind(this);
    const l = new T(
      "website",
      window,
      null,
      this._executeMessage
    );
    this.setMessageHandler(l), this._onResize = this._onResize.bind(this), y() && window.addEventListener("resize", this._onResize), this._container = o, this._initData = r, this._configuratorSettings = s;
    const d = this._createIframe();
    this._onUseFullPage = this._onUseFullPage.bind(this), this._onBackToWebsite = this._onBackToWebsite.bind(this), this._waitForIframe = a, this._container.appendChild(d), this._iframe = d, this.setupPlugins(n, this._iframe), w.set(o, !0);
  }
  static createPlanner(s, o, r, n = []) {
    return this._create(
      s,
      o,
      r,
      n
    );
  }
  static async connect(s, o = []) {
    const r = new M();
    r.viewName = s;
    const { resolve: n, promise: a } = I(), { resolve: i, promise: l } = I(), d = ({
      message: m,
      args: f
    }) => {
      switch (m) {
        case _.REGISTER_CUSTOM_VIEW_DONE:
          n();
          break;
        case _.RETURN_METHODS:
          r.handleSetup(f[0]), i();
          break;
        default:
          if (r.isSetupDone)
            return r.executeMessage({ message: m, args: f });
      }
    }, g = new T(
      "custom-view-" + s,
      window,
      window.parent,
      d
    );
    r.setMessageHandler(g);
    const h = [s];
    return g.sendMessage(
      _.REGISTER_CUSTOM_VIEW,
      h
    ), await a, g.sendMessage(_.GET_METHODS, h), await l, r.setupPlugins(
      o,
      document.body,
      "custom-view"
    ), await Promise.allSettled(r.pluginsLoaded), r;
  }
  /**
   * Method to create a new instance of a Roomle Configurator
   * @param configuratorId the id which identifies your configurator, you will get this ID from your Roomle Contact Person
   * @param container DOM container in which the configurator should be placed
   * @param initData settings with which the configurator should be started
   */
  static createConfigurator(s, o, r, n = []) {
    return this._create(
      s,
      o,
      r,
      n
    );
  }
  /**
   * Method to create a new instance of a Roomle Configurator
   * @deprecated please use "createConfigurator"
   * @param configuratorId the id which identifies your configurator, you will get this ID from your Roomle Contact Person
   * @param container DOM container in which the configurator should be placed
   * @param initData settings with which the configurator should be started
   */
  static create(s, o, r, n) {
    return this._create(
      s,
      o,
      r,
      n
    );
  }
  /**
   * Method to create a new instance of a Roomle Viewer
   * @param configuratorId the id which identifies your configurator, you will get this ID from your Roomle Contact Person
   * @param container DOM container in which the configurator should be placed
   * @param initData settings with which the configurator should be started
   */
  static createViewer(s, o, r, n = []) {
    return this._create(
      s,
      o,
      r,
      n
    );
  }
  static async _create(s, o, r, n) {
    return new Promise(async (a, i) => {
      try {
        const l = R(
          X(),
          K(r)
        );
        ee(l);
        const d = await U(
          s,
          l
        );
        r = Q(d, l);
        const g = new this(
          d,
          o,
          r,
          n,
          a
        );
        return await Promise.allSettled(g.pluginsLoaded), g;
      } catch (l) {
        return i(l);
      }
    });
  }
  teardown() {
    this._container && w.delete(this._container);
    const s = this._container.querySelector("iframe");
    s && this._container.removeChild(s), window.removeEventListener("resize", this._onResize);
  }
  _createIframe() {
    var r;
    const s = document.createElement("iframe");
    let o = ((r = this._configuratorSettings) == null ? void 0 : r.url) || "https://www.roomle.com/t/cp/";
    return this._initData.useLocalRoomle && (o = location.href.replace("embedding.html", "")), location.href.includes("roomle.gitlab.io") && (o = location.href.replace("embedding.html", "index.html")), this._initData.overrideServerUrl && (o = this._initData.overrideServerUrl), s.src = o, s.classList.add(u.CONTAINER), s.classList.add(u.FILL), s;
  }
  _onResize() {
    L(this._iframe);
  }
  _onUseFullPage() {
    this._iframe.classList.add(u.POSITION), document.documentElement.classList.add(u.OVERFLOW_HIDDEN), window.document.body.classList.add(u.OVERFLOW_HIDDEN), y() && (L(this._iframe), this._iframe.classList.add(u.ANDROID_HEIGHT));
  }
  _onBackToWebsite() {
    this._iframe.classList.remove(u.POSITION), this._iframe.classList.remove(u.ANDROID_HEIGHT), document.documentElement.classList.remove(u.OVERFLOW_HIDDEN), window.document.body.classList.remove(u.OVERFLOW_HIDDEN);
  }
  _executeMessage({ message: s, args: o }, r) {
    var n;
    if (r.source && r.source === ((n = this._iframe) == null ? void 0 : n.contentWindow))
      return s === E.REQUEST_BOOT ? this._messageHandler ? (this._messageHandler.setOutgoingMessageBus(r.source), Promise.resolve({ result: this._initData })) : (console.error("MessageHandler not set"), Promise.resolve({ error: "MessageHandler not set" })) : s === E.SETUP ? (this.handleSetup(o[0]), N(
        this.ui.callbacks,
        "onUseFullPage",
        this._onUseFullPage
      ), N(
        this.ui.callbacks,
        "onBackToWebsite",
        this._onBackToWebsite
      ), this._waitForIframe(this), setTimeout(() => {
        if (!this._messageHandler) {
          console.error("MessageHandler not set");
          return;
        }
        this._messageHandler.sendMessage(E.WEBSITE_READY);
      }, 0), Promise.resolve({ result: null })) : this.executeMessage({ message: s, args: o });
  }
}
export {
  re as default
};
